import moment from 'moment';
import 'moment-timezone';
import i18n from './i18n/i18n';
import { ChannelType, DefaultPropertyType } from './interface/core';
import {
	INACTIVITY_TIME_LIMIT,
	REACT_APP_CNP_1846_COMPANY_ID,
	REACT_APP_MAX_EMAIL_COUNT,
	SIP_DOMAIN,
	SUBACCOUNT_FLAG,
} from './base';

export enum ModalTypes {
	creditSeeMore = 'creditSeeMore',
	performanceSeeMore = 'performanceSeeMore',
	assetsSeeMore = 'assetsSeeMore',
	overviewSeeMore = 'overviewSeeMore',
	deliveryStatusSeeMore = 'DeliveryStatusSeeMore',
	delete = 'delete',
	bulkDelete = 'bulkDelete',
	bulkDetailsDelete = 'bulkDetailsDelete',
	smsTemplateDelete = 'smsTemplateDelete',
	smsSenderIdsDelete = 'smsSenderIdsDelete',
	deleteConfiguration = 'deleteConfiguration',
	publishConfiguration = 'publishConfiguration',
	cancelConfigurationForm = 'cancelConfigurationForm',
	callbackProfileModal = 'callbackProfileModal'
}

export enum SideBarTypes {
	tagsForm = 'tagsForm',
	senderIdApplyForm = 'senderIdApplyForm',
	senderIdEditForm = 'senderIdEditForm',
	senderIdView = 'senderIdView',
	contactsImport = 'contactsImport',
	contactsForm = 'contactsForm',
	viewContact = 'viewContact',
	lookup = 'lookup',
	addWhatsappTemplate = 'addWhatsappTemplate',
	viewWhatsapptemplate = 'viewWhatsappTemplate',
	editWhatsapptemplate = 'editWhatsappTemplate',
	wappNumbersForm = 'wappNumbersForm',
	wappNumbersEditForm = 'wappNumbersEditForm',
	wappReqReportForm = 'wappReqReportForm',
	sandbox = 'sandbox',
	templateApplyForm = 'templateApplyForm',
	templateEditForm = 'templateEditForm',
	templateView = 'templateView',
	addUrl = 'addUrl',
	bulkEditUrl = 'bulkEditUrl',
	uploadUrl = 'uploadUrl',
	profileSetting = 'profileSetting',
	APIKeyCreate = 'APIKeyCreate',
	APIKeyEdit = 'APIKeyEdit',
	APIKeyCreateSuccess = 'APIKeyCreateSuccess',
	CallbackProfileFilter = 'CallbackProfileFilter',
	CallbackLogsFilter = 'CallbackLogsFilter',
	CallbackProfileCreate = 'CallbackProfileCreate',
	FlowBuilderLogsFilter = 'FlowBuilderLogsFilter',
	StickyAgentModal = 'StickyAgentModal',
	PayloadModal = 'PayloadModal',
	RequestReportTemplate = 'RequestReportTemplate',
	verifiedSMSView = 'verifiedSMSView',
	SipAddUserGroupModal = 'SipAddUserGroupModal',
	EditCredentialModal = 'EditCredentialModal',
	ChangeCredentialPasswordModal = 'ChangeCredentialPasswordModal',
	RenameUserGroupModal = 'RenameUserGroupModal',
	AddEditDomainModal = 'AddEditDomainModal',
	SipAddAclModal = 'SipAddAclModal',
	RenameSipAclModal = 'RenameSipAclModal',
	ViewSound = 'ViewSound',
	configurationSelectTemplate = 'configurationSelectTemplate',
	configurationEdit = 'configurationEdit',
	RechargeSubAccount = 'RechargeSubAccount',
	GenerateReports = 'GenerateReports',
	SelectUrl = 'SelectUrl',

	VoicemailViewRecording = 'VoicemailViewRecording',
	VoicemailFilterModal = 'VoicemailFilterModal',

	WhatsappTemplatesList = 'whatsappTemplatesList',
	EmailTemplates = 'EmailTemplates',
	VoiceTemplates = 'VoiceTemplates',
	SmsTemplates = 'SmsTemplates',
	createFailoverTemplates = 'createFailoverTemplates',
	NewConfiguration = 'NewConfiguration',
	SpeechLogsFilterModal = 'SpeechLogsFilterModal',
	NewIpConfiguration = 'NewIpConfiguration',
	EditIpConfiguration = 'EditIpConfiguration',
	ViewApiConfiguration = 'ViewApiConfiguration',
	LowBalanceAlertConfig = 'LowBalanceAlertConfig',
	ReportAlertConfig = 'ReportAlertConfig',
	BillingAlertConfig = 'BillingAlertConfig',
	AddEditIpConfig = 'AddEditIpConfig',
	EmailRequestReportForm = 'emailRequestReportForm',
	EditExpiryModal = 'EditExpiryModal'
}

export const AllCountry = (): DefaultPropertyType => ({
	label: i18n.t('allCountries'),
	value: '',
});

export const InstanceAPIs = {
	StickyAgents: {
		PUT: '/update-sticky-agent',
		DELETE: '/delete-sticky-agent',
		POST: '/create-sticky-agent',
	},
	CallbackProfiles: {
		PUT: '/update-cb-profile',
		DELETE: '/delete-cb-profile',
		POST: '/create-cb-profile',
	},
	UserGroup: {
		POST: '/voice-sip-credential-group',
		PUT: '/voice-sip-credential-group',
		DELETE: '/voice-sip-credential-group',
	},
	SipCredential: {
		POST: '/voice-sip-credential',
		PUT: '/voice-sip-credential',
		DELETE: '/voice-sip-credential',
	},
	SipDomain: {
		POST: '/voice-sip-domain',
		PUT: '/voice-sip-domain',
		DELETE: '/voice-sip-domain',
	},
	SipACL: {
		POST: '/voice-sip-acl',
		PUT: '/voice-sip-acl',
		DELETE: '/voice-sip-acl',
	},
	SipIpAddresses: { POST: '/voice-sip-acl', DELETE: '/voice-sip-acl' }, // todo change urls
	ChatbotList: {
		POST: '/babble/create_chatbot/',
		PUT: '/babble/rename_bot/',
		DELETE: '/babble/delete_chatbot/',
		PUBLISH: '/babble/publish_bot/',
		UNPUBLISH: '/babble/unpublish_bot/',
		PUT_UTILITY: '/babble/utility_bot/',
		LOCK: '/babble/lock_bot/',
		RESTORE: '/babble/restore_bot/',
	},
	Chatbot: {
		POST: '/babble/add_intent/',
		PUT: '/babble/edit_intent/',
		DELETE: '/babble/delete_intent/',
		PUT_UTILITY: '/babble/utility_bot/',
	},
	SingleEmail: { POST: '/babble/email_contact/' },
	Fallbacks: {
		FALLBACKS: '/fallbacks',
	},
	DataTalk: {
		POST: '/data-talk',
	},
};

export enum Instances {
	smsOverview = 'smsOverview',
	smsOverviewSeeMore = 'smsOverviewSeeMore',
	whatsappOverview = 'whatsappOverview',
	whatsappOverviewSeeMore = 'whatsappOverviewSeeMore',
	insightCountries = 'insightCountries',
	deliveryStatus = 'delivery',
	deliveryStatusDetailed = 'deliveryStatusDetailed',
	performance = 'performance',
	performanceTabular = 'performanceTabular',
	performanceDetailed = 'performanceDetailed',
	creditTabular = 'creditTabular',
	creditDetailed = 'creditDetailed',
	credit = 'credit',
	directoryContacts = 'directoryContacts',
	assets = 'assets',
	assetsDetailed = 'assetsDetailed',
	apiKeys = 'apiKeys',
	apiKeysId = 'apiKeysId',
	apiKeysDownload = 'apiKeysDownload',
	directoryTags = 'directoryTags',
	directoryLookup = 'directoryLookup',
	whatsappNumbers = 'whatsappNumbers',
	whatsappNumbersView = 'whatsappNumbersView',
	whatsappNumbersAdd = 'whatsappNumbersAdd',
	whatsappNumbersEdit = 'whatsappNumbersEdit',
	whatsappNumbersLayout = 'whatsappNumbersLayout',
	whatsappProfileUpload = 'whatsappProfileUpload',
	whatsappSandbox = 'whatsappSandbox',
	whatsappSandboxTry = 'whatsappSandboxTry',
	smsSenderId = 'smsSenderId',
	smsTemplate = 'SmsTemplate',
	smsSenderIdView = 'smsSenderIdView',
	smsSenderIdSave = 'smsSenderIdSave',
	smsSenderIdEdit = 'smsSenderIdEdit',
	smsSenderIdDocument = 'smsSenderIdDocument',
	smsTemplateView = 'smsTemplateView',
	smsTemplateApply = 'smsTemplateApply',
	smsVerifiedSMS = 'smsVerifiedSMS',
	smsVerifiedSMSApply = 'smsVerifiedSMSApply',
	smsVerifiedSMSSenderApply = 'smsVerifiedSMSSenderApply',
	smsTemplateEdit = 'smsTemplateEdit',
	smsTemplateUrlShortener = 'smsTemplateUrlShortener',
	smsTemplateFileShortener = 'smsTemplateFileShortener',
	urlShortenerList = 'urlShortenerList',
	bulkUrlShortenerList = 'bulkUrlShortenerList',
	bulkUrlShortenerDetailList = 'bulkUrlShortenerDetailList',
	urlShortenerDownloadAll = 'urlShortenerDownloadAll',
	urlShortenerCreate = 'urlShortenerCreate',
	urlShortenerUpdate = 'urlShortenerUpdate',
	bulkUrlUpload = 'bulkUrlUpload',
	bulkDownloadAll = 'bulkDownloadAll',
	requestReport = 'requestReport',
	bulkEditExpiryDate = 'bulkEditExpiryDate',
	textlyFileUpload = 'textlyFileUpload',
	txtlyCustomDomains = 'txtlyCustomDomains',
	// vmn -Receive message
	vmnConfigurationListing = 'vmnConfigurationListing',
	vmnLogsListing = 'vmnLogsListing',
	vmnConfigurationDelete = 'vmnConfigurationDelete',
	vmnSavePublishStatus = 'vmnSavePublishStatus',
	vmnKeywordValidate = 'vmnKeywordValidate',
	vmnRecepientNumbers = 'vmnRecepientNumbers',
	vmnRetryTrigger = 'vmnRetryTrigger',

	// fail-over
	failoverConfigurations = 'failoverConfigurations',
	failoverTemplates = 'failoverTemplates',
	failoverVoiceTemplates = 'failoverVoiceTemplates',
	failoverEmailTemplates = 'failoverEmailTemplates',
	failoverLogs = 'failoverLogs',
	identifierList = 'identifierList',
	createFailoverConfigurations = 'createFailoverConfigurations',
	voiceNumberList = 'voiceNumberList',
	failoverReportListing = 'failoverReportListing',

	smsAnalyticsLogs = 'smsAnalyticsLogs',
	smsReports = 'smsReports',
	whatsappTemplate = 'whatsappTemplate',
	viewWhatsappTemplate = 'viewWhatsappTemplate',
	smsBulkUpload = 'smsBulkUpload',
	editWhatsappTemplate = 'editWhatsappTemplate',
	WhatsappTemplateLayout = 'WhatsappTemplateLayout',
	whatsappLogs = 'whatsappLogs',
	smsUploadedReports = 'smsUploadedReports',
	whatsappReports = 'whatsappReports',
	whatsappRequestReports = 'whatsappRequestReports',
	timezones = 'timezones',
	profileSetting = 'profileSetting',
	uploadPhoto = 'uploadPhoto',
	saveProfileSetting = 'saveProfileSetting',
	getProfile = 'getProfile',
	APIKeyCreate = 'APIKeyCreate',
	APIKeyEdit = 'APIKeyEdit',
	APIKeyCreateSuccess = 'APIKeyCreateSuccess',
	billingHistory = 'billingHistory',
	billingStatus = 'billingStatus',
	billingDownload = 'billingDownload',
	numberValidation = 'numberValidation',
	callbackAlert = 'callbackAlert',
	callbackFailureAlert = 'callbackFailureAlert',
	callbackProfiles = 'callbackProfiles',
	callbackProfileCreate = 'callbackProfileCreate',
	callbackProfileDelete = 'callbackProfileDelete',
	callbackProfileUpdate = 'callbackProfileUpdate',
	getCallProfileById = 'getCallProfileById',
	getCallbackProfiles = 'getCallbackProfiles',
	StickyAgentModal = 'StickyAgentModal',
	validateNumbers = 'validateNumbers',
	countryList = 'countryList',
	StickyAgents = 'StickyAgents',
	StickyAgentFilters = 'StickyAgentFilters',
	CallbackProfiles = 'CallbackProfiles',
	CallbackLogs = 'CallbackLogs',
	CallbackDynamicVars = 'CallbackDynamicVars',
	Callback = 'Callback',
	triggerCallbacks = 'triggerCallbacks',
	smsLogs = 'smsLogs',
	smsLogsSource = 'smsLogsSource',
	waNumbers = 'waNumbers',
	ChatbotList = 'ChatbotList',
	Chatbot = 'Chatbot',
	ChatbotVersion = 'ChatbotVersion',
	billingUsage = 'billingUsage',
	ChatbotOverview = 'ChatbotOverview',
	NotificationAlerts = 'NotificationAlerts',
	ToggleLowBalanceAlert = 'ToggleLowBalanceAlert',
	UpdateLowBalanceAlert = 'UpdateLowBalanceAlert',
	SmsAutomReportSettingsToggle = 'SmsAutomReportSettingsToggle',
	SmsAutomReportSettingsUpdate = 'SmsAutomReportSettingsUpdate',
	PayloadModal = 'PayloadModal',
	FlowBuilderLogs = 'FlowBuilderLogs',
	FlowLogsFilterDropdowns = 'FlowLogsFilterDropdowns',
	FlowLogsFilterFlowIds = 'FlowLogsFilterFlowIds',
	FlowLogsFilterFlowNames = 'FlowLogsFilterFlowNames',
	StepwiseLogs = 'StepwiseLogs',
	StepwisePayload = 'StepwisePayload',
	UserGroup = 'UserGroup',
	CliDropDownList = 'CliDropdownList',
	SipCredential = 'SipCredential',
	SipDomain = 'SipDomain',
	SipDomainLocation = 'SipDomainLocation',
	BridgeNumbers = 'BridgeNumbers',
	DomainValid = 'DomainValid',
	SipACL = 'SipACL',
	SipIpAddresses = 'SipIpAddresses',
	SoundList = 'SoundList',
	AddSubaccount = 'AddSubaccount',
	SubaccountListing = 'SubaccountListing',
	SuspendSubaccount = 'SuspendSubaccount',
	ResendInvite = 'ResendInvite',
	ParentLoginAsSubaccount = 'ParentLoginAsSubaccount',
	ParentLogoutAsSubaccount = 'ParentLogoutAsSubaccount',

	Voicemail = 'Voicemail',
	VoicemailRecording = 'VoicemailRecording',

	SubaccountBilling = 'SubaccountBilling',
	CreditUsage = 'CreditUsage',
	CreditHistory = 'CreditHistory',
	SubaccountReports = 'SubaccountReports',
	SubaccountGenerateReport = 'SubaccountGenerateReport',
	SubaccountIds = 'SubaccountIds',
	SMSDashboard = 'SMSDashboard',
	SMSDashboardContent = 'SMSDashboardContent',
	Contacts = 'Contacts',
	SpeechLogs = 'SpeechLogs',
	ViewRecording = 'ViewRecording',
	SttLanguages = 'SttLanguages',
	SpeechIds = 'SpeechIds',
	SubaccountCountries = 'SubaccountCountries',
	CampaignList = 'CampaignList',
	SingleEmail = 'SingleEmail',
	ChatbotReportsListing = 'ChatbotReportsListing',
	GenerateChatbotReports = 'GenerateChatbotReports',
	IpConfiguration = 'IpConfiguration',
	GetRestrictedIpAddresses = 'GetRestrictedIpAddresses',
	CreateRestrictedIpAddresses = 'CreateRestrictedIpAddresses',
	UpdateRestrictedIpAddresses = 'UpadteRestrictedIpAddresses',
	GetIpSharedConfigList = 'GetIpSharedConfigList',
	emailLogs = 'emailLogs',
	emailTemplates = 'emailTemplates',
	emailTemplatesCreate = 'emailTemplatesCreate',
	emailTemplatesDelete = 'emailTemplatesDelete',
	emailTemplatesTest = 'emailTemplatesTest',
	emailTemplatesView = 'emailTemplatesView',
	emailReports = 'emailReports',
	WhatsappCampaignDetails = 'WhatsappCampaignDetails',
	WhatsappCampaignMetrics = 'WhatsappCampaignMetrics',
	WhatsappCampaignTemplateDetails = 'WhatsappCampaignTemplateDetails',
	Settings = 'Settings',
	SmsSafeWindow = 'SmsSafeWindow',
	SmsRateLimitToggle = 'SmsRateLimitToggle',
	SmsRateLimitUpdate = 'SmsRateLimitUpdate',
	WaCallbackUrlUpdate = 'WaCallbackUrlUpdate',
	GlobalClickToCallToggle = 'GlobalClickToCallToggle',
	AutoBlackListingToggle = 'AutoBlackListingToggle',
	AutoBlackListingUpdate = 'AutoBlackListingUpdate',
	SmsSafeWindowUpdate = 'SmsSafeWindowUpdate',
	BillingAutomatedReports = 'BillingAutomatedReports',
	BillingAutomatedReportsUpdate = 'BillingAutomatedReportsUpdate',
	AudioList = 'AudioList',
	GetDocuments = 'GetDocuments',
	OnDownloadDocuments = 'OnDownloadDocuments',
	OnRenameDocuments = 'OnRenameDocuments',
	OnDeleteDocuments = 'OnDeleteDocuments',
	LoginHistory = 'LoginHistory',
	TeamMembersListing = 'TeamMembersListing',
	TeamMembersInvite = 'TeamMembersInvite',
	TeamMembersEdit = 'TeamMembersEdit',
	TeamMembersResend = 'TeamMembersResend',
	TeamMembersDelete = 'TeamMembersDelete',
	TeamMembersSendActivity = 'TeamMembersSendActivity',
	TTSConfig = 'TTSConfig',
	GetWebHookList = 'GetWebHookList',
	getWebHokkCallbackProfile = 'getWebHokkCallbackProfile',
	WebHookCallBackProfiles = 'WebHookCallBackProfiles',
	changeWebhookStatus = 'changeWebhookStatus',
	GetTwoFactorAuthentication = 'GetTwoFactorAuthentication',
	onSendOTP = 'onSendOTP',
	onReSendOTP = 'onReSendOTP',
	UpdateTwoFactorAuthentication = 'UpadateTwoFactorAuthentication',
	voiceCallUsage = 'voiceCallUsage',
	VoiceCampaignEstimate = 'VoiceCampaignEstimate',
	//Analytics-beta
	AnalyticReports = 'AnalyticReports',
	FallbackOverview = 'fallbackOverview',
	DataTalk = 'DataTalk',
	GenerateReports = 'GenerateReports',
	AnalyticLogs = 'AnalyticsLogs',
	whatsappVoiceLogs = 'whatsappVoiceLogs',
	whatsappLogsV2 = 'whatsappLogsV2',

	// Fallback
	Fallbacks = "Fallbacks",
	FallbackErrors = "FallbackErrors",
}

export const ApiMap = {
	[Instances.smsOverview]: `/insights/overview`,
	[Instances.smsOverviewSeeMore]: '/insights/overview-detail',
	[Instances.whatsappOverview]: '/insights/overview?channel=whatsapp',
	[Instances.whatsappOverviewSeeMore]:
		'/insights/overview-detail?channel=whatsapp',
	[Instances.insightCountries]: '/insights/get-country-code',
	[Instances.deliveryStatus]: '/insights/delivery-status',
	[Instances.deliveryStatusDetailed]:
		'/insights/delivery-status/detailed-view',
	[Instances.performance]: '/insights/performance',
	[Instances.performanceTabular]: '/insights/performance/tabular',
	[Instances.performanceDetailed]: '/insights/performance/detailed-view',
	[Instances.directoryContacts]: '',
	[Instances.credit]: '/insights/credit-usage',
	[Instances.creditTabular]: '/insights/credit-tabular',
	[Instances.creditDetailed]: '/insights/credit-detailed',
	[Instances.assets]: '/insights/assets',
	[Instances.assetsDetailed]: '/insights/assets-detail',
	[Instances.apiKeys]: '/api-keys',
	[Instances.apiKeysId]: '/api-keys',
	[Instances.apiKeysDownload]: '/api-key/download',
	[Instances.directoryTags]: '',
	[Instances.directoryLookup]: '/lookup',
	[Instances.whatsappNumbers]: '/whatsapp/numbers',
	[Instances.whatsappNumbersView]: '',
	[Instances.whatsappNumbersAdd]: '/whatsapp/numbers/add',
	[Instances.whatsappNumbersEdit]: '/whatsapp/numbers/edit',
	[Instances.whatsappNumbersLayout]: '/whatsapp/numbersAddLayout',
	[Instances.whatsappSandbox]: '/whatsapp/sandbox',
	[Instances.whatsappSandboxTry]: '/whatsapp/trysandbox',
	[Instances.whatsappProfileUpload]: '/profilepic',
	[Instances.smsSenderId]: '/messages/configuration/sender',
	[Instances.smsSenderIdView]: '/messages/configuration/sender',
	[Instances.smsSenderIdSave]: '/messages/configuration/sender',
	[Instances.smsSenderIdEdit]: '/messages/configuration/sender',
	[Instances.smsSenderIdDocument]: '/messages/configuration/documents',
	[Instances.smsVerifiedSMS]: '/messages/verified',
	[Instances.smsVerifiedSMSApply]: '/messages/verified',
	[Instances.smsVerifiedSMSSenderApply]: '/sms/company/vsms/senders',
	[Instances.smsAnalyticsLogs]: '',
	[Instances.smsReports]: '/messages/analytics/reports',
	[Instances.whatsappTemplate]: '/whatsapp/templates',
	[Instances.viewWhatsappTemplate]: '/whatsapp/templates',
	[Instances.editWhatsappTemplate]: '/whatsapp/templates',
	[Instances.WhatsappTemplateLayout]: '/whatsapp/templatesAddLayout',
	[Instances.whatsappLogs]: '/whatsapp/logs',
	[Instances.whatsappReports]: '/whatsapp/reports',
	[Instances.whatsappRequestReports]: '/whatsapp/reports',
	[Instances.smsTemplate]: '/messages/configuration/template',
	[Instances.smsUploadedReports]: '/messages/template/bulk-uploads',
	[Instances.smsTemplateView]: '/messages/configuration/template',
	[Instances.smsTemplateApply]: '/messages/configuration/template',
	[Instances.smsBulkUpload]: '/messages/template/bulk-upload',
	[Instances.smsTemplateEdit]: '/messages/configuration/template',
	[Instances.smsTemplateUrlShortener]:
		'/messages/configuration/template/urlshortner',
	[Instances.smsTemplateFileShortener]: '/template/fileurlshortner',
	[Instances.urlShortenerList]: '/txtly/list',
	[Instances.bulkUrlShortenerList]: '/txtly/listbulk',
	[Instances.bulkUrlShortenerDetailList]: '/txtly/list',
	[Instances.urlShortenerDownloadAll]: '/txtly/download-report',
	[Instances.urlShortenerCreate]: '/txtly/txtlyshortner',
	[Instances.urlShortenerUpdate]: '/txtly/update',
	[Instances.textlyFileUpload]: '/txtly/upload-attachment',
	[Instances.txtlyCustomDomains]: '/txtly/get-domains',
	[Instances.bulkUrlUpload]: '/txtly/upload-bulk',
	[Instances.bulkDownloadAll]: '/txtly/download-bulk',
	[Instances.requestReport]: '/txtly/request-report',
	[Instances.bulkEditExpiryDate]: '/txtly/updatemultiple',

	[Instances.vmnConfigurationListing]: '/vmn/configuration',
	[Instances.vmnLogsListing]: '/vmn/logs',
	[Instances.vmnConfigurationDelete]: '/vmn/configuration',
	[Instances.vmnSavePublishStatus]: '/vmn/configuration/status',
	[Instances.vmnKeywordValidate]: '/vmn/keyword',
	[Instances.vmnRecepientNumbers]: '/numbers/manage?',
	[Instances.vmnRetryTrigger]: '/vmn/retry',

	[Instances.failoverConfigurations]: '/failover/config',
	[Instances.failoverTemplates]: '/failover/template',
	[Instances.failoverVoiceTemplates]: '/failover/template?channel_name=voice',
	[Instances.failoverEmailTemplates]: '/failover/template?channel_name=email',
	[Instances.failoverLogs]: '/failover/logs',
	[Instances.failoverReportListing]: '',
	[Instances.identifierList]: '/messages/identifier',
	[Instances.createFailoverConfigurations]: '/failover/config',
	[Instances.voiceNumberList]: '/numbers/manage',

	[Instances.timezones]: 'timezones/all',
	[Instances.profileSetting]: '',
	[Instances.uploadPhoto]: '/profile/upload',
	[Instances.saveProfileSetting]: '/profile/update',
	[Instances.getProfile]: '/profile',
	[Instances.APIKeyCreate]: '',
	[Instances.APIKeyEdit]: '',
	[Instances.APIKeyCreateSuccess]: '',
	[Instances.billingHistory]: '/billing/history',
	[Instances.billingStatus]: '/billing/history-status-flags',
	[Instances.billingDownload]: '/presign-url',
	[Instances.callbackAlert]: '/settings/create-alert-callback',
	[Instances.callbackFailureAlert]: '/settings/create-failure-alert-callback',
	[Instances.Callback]: '/test-cb-profile',
	[Instances.callbackProfiles]: '/paginate-cb-profile',
	[Instances.callbackProfileCreate]: '/create-cb-profile',
	[Instances.numberValidation]: '/validate-mobile',
	[Instances.callbackProfileDelete]: '/delete-cb-profile',
	[Instances.callbackProfileUpdate]: '/update-cb-profile',
	[Instances.getCallProfileById]: '/get-cb-profile',
	[Instances.getCallbackProfiles]: '/paginate-cb-profile',
	[Instances.CallbackDynamicVars]: '/dynamic-variables',
	[Instances.triggerCallbacks]: '/trigger',
	[Instances.StickyAgentModal]: '',
	[Instances.validateNumbers]: '/validate-numbers',
	[Instances.countryList]: '/countries',
	[Instances.StickyAgents]: '/get-sticky-agent',
	[Instances.StickyAgentFilters]: '/sticky-agent-filters',
	[Instances.CallbackProfiles]: '/paginate-cb-profile',
	[Instances.CallbackLogs]: '/cb-logs',
	[Instances.FlowBuilderLogs]: '/flow-logs',
	[Instances.FlowLogsFilterFlowIds]: '/flow-logs',
	[Instances.FlowLogsFilterFlowNames]: '/flow-name-filter',
	[Instances.FlowLogsFilterDropdowns]: '/flow-logs-filter-dropdowns',
	[Instances.StepwiseLogs]: '/widget-logs',
	[Instances.smsLogs]: '/messages/analytics/logs',
	[Instances.smsLogsSource]: '/messages/source',
	[Instances.waNumbers]: '/whatsapp/numbers',
	[Instances.ChatbotList]: '/babble/show_bots/',
	[Instances.Chatbot]: '/babble/show_intents/',
	[Instances.ChatbotOverview]: '/babble/filtered_analysis/',
	[Instances.ChatbotVersion]: '/babble/show_versions/',
	[Instances.billingUsage]: '/billing/usage',
	[Instances.NotificationAlerts]: '/settings/notification-alerts',
	[Instances.ToggleLowBalanceAlert]: '/settings/toggle-low-balance-alert',
	[Instances.UpdateLowBalanceAlert]: '/settings/update-balance-alert',
	[Instances.SmsAutomReportSettingsToggle]: '/report-settings/toggle',
	[Instances.SmsAutomReportSettingsUpdate]: '/report-settings/update',
	[Instances.PayloadModal]: '',
	[Instances.StepwisePayload]: '/widget-logs',
	[Instances.UserGroup]: '/voice-sip-credential-group',
	[Instances.CliDropDownList]: '/user-group',
	[Instances.SipCredential]: '/voice-sip-credential',
	[Instances.SipDomain]: '/voice-sip-domain',
	[Instances.SipDomainLocation]: '/voice-sip-domain-location',
	[Instances.BridgeNumbers]: '/active-bridge-numbers',
	[Instances.DomainValid]: '/active-bridge-numbers',
	[Instances.SipACL]: '/voice-sip-acl',
	[Instances.SipIpAddresses]: '/voice-sip-acl',
	[Instances.SoundList]: '/sounds',
	[Instances.AddSubaccount]: '/subaccount',
	[Instances.SubaccountListing]: '/subaccounts',
	[Instances.SuspendSubaccount]: '/subaccount/status',
	[Instances.ResendInvite]: '/subaccount/resend',
	[Instances.ParentLoginAsSubaccount]: '/subaccount/parentLogin',
	[Instances.ParentLogoutAsSubaccount]: '/subaccount/parentLogout',

	[Instances.Voicemail]: '/voicemail',
	[Instances.VoicemailRecording]: '/voicemail-record',

	[Instances.SubaccountBilling]: '/subaccount/recharge',
	[Instances.CreditHistory]: '/subaccount/credits-history',
	[Instances.CreditUsage]: '/subaccount/credits-usage',
	[Instances.SubaccountGenerateReport]: '/subaccount/report',
	[Instances.SubaccountReports]: '/subaccount/report/list',
	[Instances.SubaccountIds]: '/subaccounts/ids',
	[Instances.SMSDashboard]: '/campaign/details',
	[Instances.SMSDashboardContent]: '/campaign/overall',
	[Instances.Contacts]: '/contacts',
	[Instances.SpeechLogs]: '/speech-logs',
	[Instances.ViewRecording]: '/get-recordings', // todo '/speech-logs-recording'
	[Instances.SttLanguages]: '/stt-languages',
	[Instances.SpeechIds]: '/speech-logs',
	[Instances.SubaccountCountries]: '/countries',
	[Instances.CampaignList]: '/campaign',
	[Instances.SingleEmail]: '/babble/email_contact/',
	[Instances.ChatbotReportsListing]: '/chat-bot/reports',
	[Instances.GenerateChatbotReports]: '/chat-bot/tabular-report',
	[Instances.IpConfiguration]: '/ipconfig',
	[Instances.GetRestrictedIpAddresses]: '/settings/allowed-ips',
	[Instances.CreateRestrictedIpAddresses]: '/settings/allowed-ips',
	[Instances.UpdateRestrictedIpAddresses]: '/settings/allowed-ips',
	[Instances.GetIpSharedConfigList]: '/shared-configs',

	[Instances.emailLogs]: '/email/logs',
	[Instances.emailTemplates]: '/email/templates',
	[Instances.emailTemplatesCreate]: '/email/templates',
	[Instances.emailTemplatesDelete]: '/email/templates',
	[Instances.emailTemplatesTest]: '/email',
	[Instances.emailTemplatesView]: '/email/templates',
	[Instances.emailReports]: '/email/reports',

	[Instances.WhatsappCampaignDetails]: '/campaign/details',
	[Instances.WhatsappCampaignMetrics]: '/campaign/wa-metrics',
	[Instances.WhatsappCampaignTemplateDetails]: '/whatsapp/templates',
	[Instances.Settings]: '/settings/team/settings',
	[Instances.SmsSafeWindow]: '/time',
	[Instances.SmsSafeWindowUpdate]: '/time',
	[Instances.SmsRateLimitToggle]: '/settings/update/team/settings',
	[Instances.SmsRateLimitUpdate]: '/settings/team/settings/msg/cap/update',
	[Instances.WaCallbackUrlUpdate]: '/settings/team/settings/whastpp_callback',
	[Instances.GlobalClickToCallToggle]:
		'/settings/update/team/settings/conversation',
	[Instances.AutoBlackListingToggle]:
		'/settings/team/settings/blacklists/enabling',
	[Instances.AutoBlackListingUpdate]: '/settings/team/settings/blacklists',
	[Instances.BillingAutomatedReports]: '/reports/configuration',
	[Instances.BillingAutomatedReportsUpdate]: '/reports/configuration',
	[Instances.AudioList]: '/sounds',
	[Instances.GetDocuments]: '/documents',
	[Instances.OnDownloadDocuments]: '/documents/download',
	[Instances.OnRenameDocuments]: '/documents/rename',
	[Instances.OnDeleteDocuments]: '/documents/delete',
	[Instances.LoginHistory]: '/login-history',
	[Instances.TeamMembersListing]: '/team',
	[Instances.TeamMembersInvite]: '/team/invite',
	[Instances.TeamMembersEdit]: '/team/edit',
	[Instances.TeamMembersDelete]: '/team/delete',
	[Instances.TeamMembersResend]: '/team/resend-invite',
	[Instances.TeamMembersSendActivity]: '/send-activity',
	[Instances.GetTwoFactorAuthentication]: '/settings/enable-2fa',
	[Instances.onSendOTP]: '/sendotp',
	[Instances.onReSendOTP]: 'resendotp',
	[Instances.UpdateTwoFactorAuthentication]: '/settings/enable-2fa',
	[Instances.TTSConfig]: '/tts-config',
	[Instances.GetWebHookList]: '/whatsapp',
	[Instances.getWebHokkCallbackProfile]: '/whatsapp/:Id/callback-profile',
	[Instances.WebHookCallBackProfiles]: '/paginate-cb-profile',
	[Instances.changeWebhookStatus]: '/whatsapp/:Id/callback-profile/webhooks',
	[Instances.voiceCallUsage]: '/call-usage',
	[Instances.VoiceCampaignEstimate]: '/campaign-estimate-voice',
	//Analytics-beta
	[Instances.AnalyticReports]: '/report',
	[Instances.FallbackOverview]: '/fallback',
	[Instances.DataTalk]: '/data-talk',
	[Instances.GenerateReports]: '/',
	[Instances.AnalyticLogs]: '/',
    [Instances.whatsappVoiceLogs]: '/whatsapp/voicelogs',
	[Instances.whatsappLogsV2]: '/whatsapp/logs',
	[Instances.Fallbacks]: '/fallbacks',
	[Instances.FallbackErrors]: '/fallbacks/sync/errors',
};

export const DeliveryStackBarColorCode = [
	'#9DC9EB',
	'#F8D648',
	'#76CAAC',
	'#DF9164',
	'#D174B7',
	'#949CD2',
];

export const CreditLineGraphColorCode = ['#949CD2', '#D174B7', '#1676EE'];

export const TimeDropDownOptions: Array<DefaultPropertyType> = [
	{
		label: 'dateFilterToday',
		value: [
			moment().startOf('day').unix(),
			// .milliseconds(0)
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().unix(),
			'1',
			// .milliseconds(0)
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
	{
		label: 'dateFilterWeek',
		value: [
			moment().startOf('week').unix(),
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().endOf('day').unix(),
			'2',
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
	{
		label: 'dateFilterMonth',
		value: [
			moment().startOf('month').unix(),
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().endOf('day').unix(),
			'3',
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
	{
		label: 'dateFilterLastThreeMonth',
		value: [
			moment().subtract(3, 'month').unix(),
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().endOf('day').unix(),
			'4',
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
	{
		label: 'dateFilterLastYear',
		value: [
			moment().subtract(1, 'year').startOf('day').unix(),
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().endOf('day').unix(),
			'5',
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
];

export const FallbackTimeDropDownOptions: Array<DefaultPropertyType> = [
	{
		label: 'dateFilterToday',
		value: [
			moment().startOf('day').unix(),
			// .milliseconds(0)
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().unix(),
			'1',
			// .milliseconds(0)
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
	{
		label: 'dateFilterWeek',
		value: [
			moment().startOf('week').unix(),
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().endOf('day').unix(),
			'2',
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
	{
		label: 'dateFilterMonth',
		value: [
			moment().startOf('month').unix(),
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().endOf('day').unix(),
			'3',
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
	{
		label: 'dateFilterLastThreeMonth',
		value: [
			moment().subtract(3, 'month').add(1,'day').unix(),
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().endOf('day').unix(),
			'4',
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
	{
		label: 'Last 6 Months',
		value: [
			moment().subtract(6, 'month').startOf('day').add(1,'day').unix(),
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
			moment().endOf('day').unix(),
			'5',
			// .toISOString(true)
			// .replace(/.[^.]*$/g, 'Z'),
		],
	},
];

export const ChannelOptions: Array<DefaultPropertyType> = Object.values(
	ChannelType
).map<DefaultPropertyType>((value) => ({
	label: i18n.t(`channelType${value}`),
	value,
}));

export const CampaignTabs = [
	{
		title: 'Campaigns',
		to: '/campaigns/voice',
		key: 'campaigns',
	},
	{
		title: 'Sound Manager',
		to: '/channels/voice/sounds',
		key: 'soundmanager',
	},
	{
		title: 'Logs',
		to: '/channels/voice/logs',
		key: 'logs',
	},
	{
		title: 'Reports',
		to: '/channels/voice/reports',
		key: 'reports',
	},
];

export enum LatencyColorCodes {
	first = '#56A455',
	second = '#BED6BA',
	third = '#F2B1AB',
	fourth = '#E26D68',
}

export enum AccountType {
	prepaid = 'prepaid',
	postpaid = 'postpaid',
}

export const AssetsStatusColorMap = {
	Approved: 'success',
	'Under Verification': 'warning',
	Rejected: 'error',
	'Need Attention': 'error',
	Deleted: 'error',
	Inactive: 'inactive',
	'Under Review': 'warning',
	Pending: 'warning',
	Resubmitted: 'success',
	Active: 'success',
	Unsubscribed: 'inactive',
	Failed: 'error',
	Successful: 'success',
	Others: 'inactive',
};

export type CallbackType = (...args: string[]) => void;

export const TITLE_VALIDATION_REGEX = /[^a-zA-Z0-9-_ ]/;
export const VOICE_CAMPAIGN_SERVICE_ID = '2';
export const VOICE_C2C_SERVICE_ID = '5';

export const VmnV2ApiInstances = ['vmnRecepientNumbers'];
export const V2ApiInstances = ['whatsappLogsV2'];

export const SubaccountInstances = [
	'AddSubaccount',
	'SubaccountListing',
	'SuspendSubaccount',
	'SubaccountBilling',
	'CreditHistory',
	'CreditUsage',
	'SubaccountReports',
	'SubaccountGenerateReport',
	'SubaccountIds',
	'SubaccountCountries',
	'ResendInvite',
];

export const dashboardUrls = ['/dashboard', '/dashboard/all'];
export const campaignsUrls = ['/campaigns', '/campaigns/'];
export const directoryUrls = [
	'/directory',
	'/directory/contact-tags',
	'/lookup',
];
export const channelsUrls = ['/channels'];
export const emailUrls = [
	'/channels/email',
	'/channels/email/logs',
	'/channels/email/reports',
];
export const voiceUrls = [
	'/channels/voice',
	'/channels/voice/campaigns',
	'/channels/voice/sounds',
	'/channels/voice/logs',
	'/channels/voice/reports',
	'/channels/voice/sticky-agents',
	'/channels/voice/sip-user-group',
	'/channels/voice/sip-domain',
	'/campaigns/voice/launch',
];
export const smsUrls = [
	'/channels/sms/sender-id',
	'/channels/sms/templates',
	'/channels/sms/logs',
	'/channels/sms/reports',
	'/channels/sms/uploaded-reports',
	'/channels/sms/verified',
	'/channels/sms/settings',
	'/channels/sms/campaigns',
	'/channels/sms',
];
export const flowBuilderUrls = [
	'/flow-builder',
	'/flow-builder/flows',
	'/flow-builder/logs',
];
export const numbersUrls = ['/number', '/numbers/manage', '/numbers/subscribe'];
export const verifyUrls = [
	'/verify',
	'/verify/dashboard',
	'/verify/configuration',
	'/verify/templates',
	'/verify/logs',
];
export const chatbotUrls = ['/chatbot/overview', '/chatbot/report'];

export const whatsappCampaignUrls = [
	'/campaigns/whatsapp/launch',
	'/campaigns/whatsapp/campaigns',
	'/campaigns/whatsapp',
	'/campaigns/whatsapp/detail',
];
export const conversationUrls = [
	'/conversations',
	'/conversations/dashboard',
	'/conversations/templates',
];
export const urlShortnerUrl = [
	'/URL-shortener',
	'/URL-shortener/single-url',
	'/URL-shortener/bulk-upload',
];

export const subaccountUrls = [
	'/subaccounts',
	'/subaccounts/reports',
	'/subaccounts/credits-history',
	'/subaccounts/credits-usage',
	'/subaccounts/manage-subaccounts',
	'/add-subaccount',
	'/edit-subaccount',
];

export const developersUrl = [
	'/developers/api-keys',
	'/developers/ip-configurations',
];

export const billingUrls = [
	'/billing',
	'/billing/history',
	'/billing/auto-debit',
];
export const integrationDirectoryUrl = ['/integrations-directory'];

export const settingsUrl = ['/settings/callback-profiles'];

export const fallbackUrl = [
	'/fallback/overview',
];

export const whatsappCampaignLaunchUrls = [
	'/campaigns/whatsapp/launch',
];

export const voiceCampaignLaunchUrls = [
	'/campaigns/voice/launch',
];

export const receiveMessageUrl = ['/channels/sms/receive-message'];
export const enterpriseCustomerTypeId = [2];
export const resellerCustomerTypeId = [4];
export const enterpriseSubaccountCustomerTypeId = [3];
export const subaccountCustomerTypeId = [3, 5];
export const parentCustomerTypeId = [2, 4];
export const resellerSubaccountCustomerTypeId = [5];
export const kaleyraExpertDefaultRoleId = [12];
export const kaleyraExpertExtendedRoleId = [13];
export const subaccountFlag = SUBACCOUNT_FLAG ? SUBACCOUNT_FLAG : 'true';
export const DOMAIN_VALIDATION_REGEX = /[^a-zA-Z0-9-_]/;
export const ALPHANUMERIC_WITHOUT_LEADING_TRAILING_HYPHEN_UNDERSCORE = /^[a-zA-Z0-9][a-zA-Z0-9-_]{1,30}[a-zA-Z0-9]$/;
export const SIP_PATTERN: string = `^sip:[a-zA-Z0-9]{1}[a-zA-Z0-9-_]{1,30}[a-zA-Z0-9]{1}[@]{1}${SIP_DOMAIN}$`;

export const LoginInstance = [
	'ParentLoginAsSubaccount',
	'ParentLogoutAsSubaccount',
];
export const enable_failover_companies = ['Z89bin15b4f4'];
export const internal_domains = ['tatacommunications.com'];
export const inactivityTimeLimit = Number(INACTIVITY_TIME_LIMIT || 900000); // In Milliseconds
export const supportRoleId = [6];
export const nonPrimaryRoleId = [6, 8, 9, 10];
export const viewOnlyRoleId = [9,10,12,13];
export const numberRoleId = [8];
export const operationRoleId = [10];
export const comManagerRoleId = [9];
export const ownerRoleId = [1];
export const whatsappOnlyRoleId = [11];
export const kaleyraExpertRoles = [12,13];
export const userPodEu = ['EU'];
export const userPodUS = ['US'];
export const Pod_SG = 'SG';
export const Pod_IN = 'IN';
export const Pod_EU = 'EU';
export const country_code_IN = 277;
export const maxEmailLimit = Number(REACT_APP_MAX_EMAIL_COUNT || 10);

export const SMS_SOURCE_LABEL: Record<string, string> = {
	API: 'API',
	WEB: 'Web',
	CAMPAIGN: 'Campaign',
	PLUGIN: 'Plugin',
	ELOQUA: 'Eloqua',
	LEADSQUARED: 'LeadSquared',
	ZOHOCRM: 'ZohoCRM',
	RESPONSYS: 'Responsys',
	SHOPIFY: 'Shopify',
	WEBENGAGE: 'WebEngage',
	CLEVERTAP: 'CleverTap',
	BRAZE: 'Braze',
	HUBSPOT: 'Hubspot',
	SALESFORCE: 'Salesforce',
	ZAPIER: 'Zapier',
	FAILOVER: 'Failover',
	MOENGAGE: 'Moengage',
	ZOHODESK: 'ZohoDesk',
	SFTPCAMP: 'SFTPCAMP',
};

export const CNP_1846_Company = REACT_APP_CNP_1846_COMPANY_ID; // https://kaleyra.atlassian.net/browse/CNP-1846

export const generalSettingsSliderTitleAndFooterData = [
	{
		index: 0,
		sliderTitle: 'SMS Rate Limit',
	},
	{
		index: 1,
		sliderTitle: 'Click to Call',
	},
	{
		index: 2,
		sliderTitle: 'Auto Blocklisting on Directory',
	},
	{
		index: 3,
		sliderTitle: 'Configure Time Window',
	},
	{
		index: 4,
		sliderTitle: 'WhatsApp Callback URLs',
	},
];

export const generalSettingsSliderLabels = {
	smsLimitMessageLimit: 'Message Limit',
	smsLimitTime: 'Time Period',
	smsLimitCategory: 'Category',
	autoBlacklistingSMSStatus: 'SMS Status/Error',
	autoBlacklistingNoOfSMS: 'No of SMS',
	autoBlacklistingNoOfDays: 'No of Days',
	whatsAppCallbackURl: 'Callback URLs',
	smsSafeToSendWindowCategory: 'Category',
	smsSafeToSendWindowStartTime: 'Start Time',
	smsSafeToSendWindowEndTime: 'End Time',
	smsSafeToSendWindowActionPostEndTime: 'Preferred Action Post End Time',
};

export const teamMembersTagStatus: { [index: number]: string } = {
	1: 'active',
	9: 'deleted',
	4: 'suspended',
	6: 'invited',
	5: 'internal',
	0: 'inactive',
};

export const teamMembersTagText: { [index: string]: string } = {
	active: 'Active',
	deleted: 'Deleted',
	suspended: 'Need Attention',
	invited: 'Invitation Sent',
	internal: 'Internal',
	inactive: 'Inactive',
};

export const teamMembersTagType: { [index: string]: string } = {
	active: 'success',
	deleted: 'error',
	invited: 'warning',
	inactive: 'info',
	suspended: 'error',
};

export const teamMembersRoles = {
	1: 'Owner',
	2: 'Admin',
	3: 'User',
	6: 'Support',
	8: 'Numbers Read Only',
	9: 'Communication Manager',
	10: 'Operational User',
	11: 'Whatsapp Only',
	12: 'Kaleyra Expert',
	13: 'Kaleyra Expert',
};

export const SMSRoutes: { [index: string]: string } = {
	OTP: 'OTP',
	MKT: 'Marketing',
	TXN: 'Transactional',
	TXND: 'Transactional DND',
	M2M: 'M2M',
};

export const whiteListedEmailKeywords = [
	"mallikarjun",
	"kaushik",
	"ulatsing",
	"manjunath",
	"santosh.patil",
	"atul",
	"kcloud-voice",
	"wigzo",
	"shiprocket",
	"convertway",
	"shipway",
	"orai-robotics.com",
	"colearn",
	"media.edu.az",
	"rahul.thakur@paymeindia.in",
    "rahul.thakur+paymeindia@paymeindia.in",
    "vineet.daniel+paymeotp@paymeindia.in",
];
